var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "72px",
    viewBox: "0 0 47 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F125BA6B-8CC7-40A2-A4D9-6021BF8F0FBD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "r4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geek-Support_LP_r4",
    transform: "translate(-1178.000000, -881.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 770.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SUPPORT-DEVICES",
    transform: "translate(183.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NETWORK-SETUP",
    transform: "translate(962.529298, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON-NETWORK",
    transform: "translate(28.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-42",
    stroke: "#491D72",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "35.5449481 54.9884946 13.4884946 75.4884946 28.03236 32.4884946 42.4884946 75.4884946 20.5449481 54.9884946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9884946,12.4884946 C36.5489083,12.4884946 43.4884946,19.428081 43.4884946,27.9884946 C43.4884946,32.1879851 41.8085177,36.1246728 38.8796674,39.017203 C36.5428519,41.3250401 33.5320174,42.8438004 30.2523085,43.3241606 C29.4326266,43.4442148 28.67082,42.8770544 28.5507658,42.0573724 C28.4307117,41.2376905 28.9978721,40.4758838 29.817554,40.3558297 C32.4597618,39.9688406 34.8859169,38.7450112 36.7716232,36.8826892 C39.1354326,34.5481928 40.4884946,31.3775644 40.4884946,27.9884946 C40.4884946,21.0849353 34.892054,15.4884946 27.9884946,15.4884946 C21.0849353,15.4884946 15.4884946,21.0849353 15.4884946,27.9884946 C15.4884946,30.8640733 16.4605563,33.5870085 18.2179233,35.7858666 C18.7351289,36.4330063 18.6297966,37.3768947 17.9826569,37.8941004 C17.3355173,38.4113061 16.3916288,38.3059738 15.8744231,37.6588341 C13.6958036,34.9328951 12.4884946,31.5509859 12.4884946,27.9884946 C12.4884946,19.428081 19.428081,12.4884946 27.9884946,12.4884946 Z",
    id: "Oval",
    fill: "#17A7A7",
    fillRule: "nonzero",
    transform: "translate(27.988495, 27.914344) rotate(-20.000000) translate(-27.988495, -27.914344) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5813962,49.4317149 C34.8314953,49.0445313 39.5573393,46.7720148 43.0845106,43.2885833 C47.0314711,39.3905682 49.4774578,33.9762495 49.4774578,27.99064 C49.4774578,16.1165179 39.8515799,6.49063998 27.9774578,6.49063998 C16.1033357,6.49063998 6.47745777,16.1165179 6.47745777,27.99064 C6.47745777,33.3267113 8.42138757,38.2087535 11.6397058,41.9672252",
    id: "Oval",
    stroke: "#17A7A7",
    strokeWidth: 3,
    strokeLinecap: "round",
    transform: "translate(27.977458, 27.961177) rotate(-22.000000) translate(-27.977458, -27.961177) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#17A7A7",
    cx: 27.9884946,
    cy: 27.9884946,
    r: 6.5
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork);
export default __webpack_public_path__ + "static/media/ICON-NETWORK.f580280eb9171e018ec1d905d7384a28.svg";
export { ForwardRef as ReactComponent };